import styled from 'styled-components';

export const CellMessageWrapper = styled.div`
  font-style: italic;
  color: ${({ theme }) => theme.color.gray2};
  margin: .5rem 0;
`;
